import axios from "axios";
import { API_BASE_URL } from "../../../config";

export async function fetchAdminLeaderboardHistory({ page = 1, limit = 12 } = {}) {
  const token = localStorage.getItem("adminToken");
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));

  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/admin/leaderboard/history?${params.toString()}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
}
